import React from 'react';
import { Switch } from 'react-router-dom';
import { ContentRoute } from '../../../_metronic/layout';
import { DashboardPage } from './DashboardPage';
import { FlowsDashboardPage } from './FlowsDashboardPage';

export default function DashboardRoute() {
  return (
    <Switch>
      <ContentRoute path="/dashboard" exact component={DashboardPage} />
      <ContentRoute
        path="/dashboard/flows"
        exact
        component={FlowsDashboardPage}
      />
      <ContentRoute path="/dashboard/:id" exact component={DashboardPage} />
    </Switch>
  );
}
